<template>
  <div class="animated fadeIn">
    <loading v-if="vLoading" />
    <v-card class="text-center pb-12" v-if="isBusy">
      <cube></cube>
      <span style="font-size: 16px">در حال بارگذاری ...</span>
    </v-card>

    <div v-else>
      <b-card-group deck>
        <!-- card1 -->
        <b-card
          bg-variant="primary"
          text-variant="white"
          v-b-tooltip="{
            title: 'برای ورود کلیک نمایید',
            placement: 'bottom',
            variant: 'primary',
          }"
          style="cursor: pointer"
          @click="gotoHighPriority()"
        >
          <v-row>
            <v-col cols="9">
              <h3>
                <h2>
                  <b-badge variant="defualt">{{
                    factoryDashboard.orderItems
                  }}</b-badge>
                </h2>
                <b-card-text>
                  تعداد اقلام تولید با اولویت بالا
                  <br />
                  <br />
                </b-card-text>
              </h3>
            </v-col>
            <v-col cols="3">
              <h3 class="text-left">
                <i class="fa fa-object-ungroup"></i>
              </h3>
            </v-col>
          </v-row>
        </b-card>
        <!-- card2 -->
        <b-card bg-variant="success" text-variant="white">
          <v-row>
            <v-col cols="10">
              <h3>
                <h2>
                  <b-badge variant="defualt">{{
                    factoryDashboard.ordersNo
                  }}</b-badge>
                </h2>
                <b-card-text>
                  تعداد کل سفارش های در حال تولید
                  <br />
                  <br />
                </b-card-text>
              </h3>
            </v-col>
            <v-col cols="2">
              <h3 class="text-left">
                <i class="fa fa-hourglass"></i>
              </h3>
            </v-col>
          </v-row>
        </b-card>
        <!-- card3 -->
        <b-card
          bg-variant="warning"
          text-variant="white"
          v-b-tooltip="{
            title: 'برای ورود کلیک نمایید',
            placement: 'bottom',
            variant: 'warning',
          }"
          style="cursor: pointer"
          @click="gotoChat()"
        >
          <v-row>
            <v-col cols="10">
              <h2>
                <b-badge variant="defualt">{{
                  factoryDashboard.unseenMessages
                }}</b-badge>
              </h2>
              <h3>
                <b-card-text style="vertical-align: center">
                  تعداد کل پیام های خوانده نشده چت
                  <br />
                  <br />
                </b-card-text>
              </h3>
            </v-col>
            <v-col cols="2">
              <h3 class="text-left">
                <i class="fa fa-comments"></i>
              </h3>
            </v-col>
          </v-row>
        </b-card>
        <!-- card4 -->
        <b-card
          bg-variant="info"
          text-variant="white"
          v-b-tooltip="{
            title: 'برای ورود کلیک نمایید',
            placement: 'bottom',
            variant: 'info',
          }"
          style="cursor: pointer"
          @click="gotoTasks()"
        >
          <v-row>
            <v-col cols="10">
              <h3>
                <b-card-text class="pt-6 mt-6">
                  اقلام در حال تولید
                  <br />
                  <br />
                </b-card-text>
              </h3>
            </v-col>
            <v-col cols="2">
              <h3 class="text-left">
                <i class="fa fa-edit"></i>
              </h3>
            </v-col>
          </v-row>
        </b-card>
      </b-card-group>
      <br />
      <b-card header-bg-variant="primary" header-text-variant="white">
        <template v-slot:header>
          <h4>سفارش‌های ارسال شده امروز</h4>
        </template>
        <br />

        <b-card class="shadow p-3 mb-5 bg-white rounded">
          <b-table
            responsive
            show-empty
            :items="factoryDashboard.orders"
            :fields="fields"
            empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
            empty-text="رکوردی برای نمایش وجود ندارد"
            striped
            :busy="isBusy"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.value }}
              </div>
            </template>

            <template v-slot:cell(progress)="data">
              <b-progress
                :value="data.item.progress"
                variant="success"
                :striped="striped"
                show-progress
                animated
              ></b-progress>
            </template>
            <template v-slot:cell(operation)="data">
              <div style="text-align: center; vertical-align: middle">
                <b-btn
                  variant="success"
                  class="mr-1"
                  @click="showModalFollow(data.item)"
                  >ثبت پیگیری</b-btn
                >
              </div>
            </template>
            <template v-slot:cell(code)="data">
              <div style="text-align: center; vertical-align: middle">
                <a
                  :href="'/' + role + '/order/' + data.item.id"
                  target="_blank"
                  >{{ data.item.code }}</a
                >
              </div>
            </template>
            <template v-slot:cell(customerName)="data">
              <a
                :href="'/' + role + '/customerProfile/' + data.item.customerId"
                >{{ data.item.customerName }}</a
              >
            </template>
            <div slot="table-busy" class="text-center text-danger my-2">
              <strong>در حال بارگذاری...</strong>
              <br />
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </b-table>
        </b-card>
        <br />
      </b-card>
    </div>
  </div>
</template>

<script>
import Axios from "axios";
import router from "../../router";

export default {
  components: {
    
  },
  data: function () {
    return {
      variant: "info",
      striped: true,
      max: 100,
      isBusy: false,
      content: "",
      config: {
        toolbar: [
          [
            "Bold",
            "Italic",
            "Underline",
            "Strike",
            "Subscript",
            "Superscript",
            "TextColor",
            "Font",
            "FontSize",
          ],
        ],
        height: 200,
      },
      factoryDashboard: [],
      fields: [
        { key: "requestId", label: "شماره درخواست مشتری" },
        { key: "factoryDate", label: "تاریخ ابلاغ" },
        { key: "registerDate", label: "تاریخ ثبت اولیه استعلام" },
        { key: "factoryStatus", label: "وضعیت سفارش " },
        { key: "priority", label: "اولویت " },
      ],
      role: "",
    };
  },
  methods: {
    showDashboard() {
      this.isBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/user/factoryDashboard",
        {},
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          if (res.status == 200) {
            this.factoryDashboard = res.data;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
          this.isBusy = false;
        });
    },

    gotoHighPriority() {
      localStorage.setItem("highPriority", true);
      this.$router.push("/factory/orderItemsPerStatus");
    },
    gotoChat() {
      this.$router.push("/allChats");
    },
    gotoTasks() {
      router.push("/" + this.role + "/productionTasks");
    },
  },

  mounted() {
    this.showDashboard();
    this.role = window.localStorage.getItem("role");
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
</style>
